<script>
  import { AppController } from "../AppController";
  import { ui } from "../store.js";
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
  } from "sveltestrap";
  import { createEventDispatcher } from "svelte";
  import { form } from "../validate.js";

  let phoneNumber = "";

  const { validate, ...modalForm } = form(() => ({
    phone: { value: phoneNumber, validators: ["phone"] },
  }));

  const dispatch = createEventDispatcher();

  const hide = () => AppController.displayTestAlertModal(false);

  const send = () => {
    dispatch("sendTestVoiceAlert", phoneNumber);
    hide();
  };
</script>

<Modal isOpen={$ui.displayTestAlertModal} {hide}>
  <ModalHeader {hide}>Send Test Voice Alert</ModalHeader>
  <ModalBody>
    <p>
      Enter a phone number to send a test voice alert to. Phone number must be
      different than the phone number configured to send alerts from.
    </p>
    <div class="form-group">
      <input
        type="text"
        bind:value={phoneNumber}
        use:validate={phoneNumber}
        class="form-control"
        class:border-danger={!$modalForm.phone.valid}
        id="input-cell-1"
        placeholder="Phone number"
      />
      {#if !$modalForm.phone.valid}
        <p class="text-danger text-small">
          Must be valid phone number (eg 612-633-9090 or (612) 633-9090)
        </p>
      {/if}
    </div>
  </ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={send}>Send</Button>
    <Button color="secondary" on:click={hide}>Cancel</Button>
  </ModalFooter>
</Modal>
